import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 px-4 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="mb-20 text-center">
          <p className="text-sm text-gray-800 mb-6 font-semibold tracking-wider" style={{ fontFamily: 'Courier New, monospace' }}>/ About Me</p>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold text-black mb-8 leading-tight">
            Creative at the <span className="text-orange-500 font-bold">Core</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-800 max-w-3xl mx-auto font-semibold leading-relaxed">
            Creator. Developer. Innovator. Problem-solver.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Left Content */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-[40px] p-12 md:p-14 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-500">
            <div className="space-y-8">
              <p className="text-lg md:text-xl text-gray-800 leading-relaxed font-medium">
                A multi-disciplinary digital creator specializing in graphics, YouTube automation, AI-driven finance systems, SaaS web & app development, automation workflows, and chatbot development.
              </p>
              <p className="text-lg md:text-xl text-gray-800 leading-relaxed font-medium">
                I bring together creativity and technical expertise to build solutions that work. From visual design to scalable SaaS platforms and intelligent automation, I focus on execution quality and problem-solving strength.
              </p>
              <div className="pt-6">
                <p className="text-3xl md:text-4xl text-black leading-relaxed font-bold italic">
                  My impact is incomparable.
                </p>
              </div>
            </div>
          </div>

          {/* Right Content - Expertise Card */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-[40px] p-12 md:p-14 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-500">
            <h3 className="text-2xl md:text-3xl font-bold text-black mb-8">
              Core Expertise
            </h3>
            
            <div className="space-y-6">
              <div className="group flex items-start gap-4 p-4 rounded-2xl hover:bg-orange-50 transition-all duration-300">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <span className="text-white text-xl font-bold">6</span>
                </div>
                <div>
                  <p className="text-base md:text-lg font-semibold text-black">Core Domains</p>
                  <p className="text-sm text-gray-700 mt-1">Multi-disciplinary expertise</p>
                </div>
              </div>

              <div className="group flex items-start gap-4 p-4 rounded-2xl hover:bg-orange-50 transition-all duration-300">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <span className="text-white text-2xl">✓</span>
                </div>
                <div>
                  <p className="text-base md:text-lg font-semibold text-black">Technical Clarity</p>
                  <p className="text-sm text-gray-700 mt-1">Focused on execution quality</p>
                </div>
              </div>

              <div className="group flex items-start gap-4 p-4 rounded-2xl hover:bg-orange-50 transition-all duration-300">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <span className="text-white text-2xl">★</span>
                </div>
                <div>
                  <p className="text-base md:text-lg font-semibold text-black">Real-World Impact</p>
                  <p className="text-sm text-gray-700 mt-1">Attention to detail</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Impact Statement - Full Width */}
        <div className="text-center max-w-5xl mx-auto bg-black rounded-[40px] p-12 md:p-16">
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-relaxed">
            I work with founders, product teams, companies and brands based on strategy and innovation. I set one goal, cut noise, and move. When the job is done, the result is live and measured, not just designed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;